export default __webpack_public_path__ + "static/media/running.845bfc6f.png";